import React from "react";
import { PowerSkillLastTestResponse } from "../../typings/powerskill";
import PowerSkillLastTest from "./PowerSkillLastTest";
import { Card } from "../UI/Card";
import Button from "../UI/Button";
import { Play, Sparkles, Zap } from "lucide-react";

interface PowerSkillTestIntroProps {
  loading: boolean;
  lastTest: PowerSkillLastTestResponse | null;
  onStartTest: () => void;
  onViewLastTestDetail: () => void;
}

const PowerSkillTestIntro: React.FC<PowerSkillTestIntroProps> = ({
  loading,
  lastTest,
  onStartTest,
  onViewLastTestDetail,
}) => {
  return (
    <div className="riasec-container p-3">
      <div className="w-full">
        <div className="flex flex-wrap">
          <div className="w-full">
            <h5 className="text-2xl font-bold mb-4 text-center text-foreground">
              Kelase PowerSkills
            </h5>
            <Card className="p-6 border-orange-100 shadow-md">
              <div className="flex items-center gap-3 mb-4 text-primary">
                <Sparkles className="w-6 h-6" />
                <h6 className="font-bold text-lg">Kenali Kekuatan Dirimu!</h6>
              </div>

              <p className="text-gray-700 text-justify mb-4 leading-relaxed">
                Cari tahu cara belajarmu, cara kamu bekerja sama, dan sikap
                hebat yang sudah kamu miliki.
              </p>

              <div className="w-full flex justify-center mt-8">
                <Button
                  primary
                  block
                  className="gradient-primary text-white text-lg font-bold py-6 rounded-xl shadow-lg transition-transform active:scale-95 border-none"
                  onClick={onStartTest}
                  disabled={loading}
                >
                  <Play className="fill-current" />{" "}
                  {loading ? "Memuat..." : "Mulai Tes Sekarang"}
                </Button>
              </div>
            </Card>

            {lastTest && (
              <div className="mt-8">
                <PowerSkillLastTest
                  lastTest={lastTest}
                  onViewDetail={onViewLastTestDetail}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PowerSkillTestIntro;
